
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54 77a2 2 0 00-2 2v23a2 2 0 004 0V79a2 2 0 00-2-2zm20 0a2 2 0 00-2 2v23a2 2 0 004 0V79a2 2 0 00-2-2z"}}),_c('path',{attrs:{"d":"M74 64.2a14 14 0 10-19.11 0C49.48 65.23 44 70 44 76v26a2 2 0 004 0V76c0-3.89 4.63-8 9-8h15a8.43 8.43 0 018 8v26a2 2 0 004 0V76a12.36 12.36 0 00-10-11.8zM54.46 54a10 10 0 1110 10 10 10 0 01-10-10zM101 75a2 2 0 00-2 2v24a2 2 0 004 0V77a2 2 0 00-2-2z"}}),_c('path',{attrs:{"d":"M101.93 65.05a11 11 0 10-8.44 4h.34L94 69h7a6.15 6.15 0 016 6v20a2 2 0 004 0V75a10.15 10.15 0 00-9.07-9.95zM86.49 58a7 7 0 117 7 7 7 0 01-7-7zM44 42a11 11 0 1111-11 11 11 0 01-11 11zm0-18a7 7 0 107 7 7 7 0 00-7-7zm40 18a11 11 0 1111-11 11 11 0 01-11 11zm0-18a7 7 0 107 7 7 7 0 00-7-7z"}}),_c('path',{attrs:{"d":"M64 0a64 64 0 1064 64A64.07 64.07 0 0064 0zm0 4a59.79 59.79 0 0141 16.21L20.21 105A60 60 0 0164 4zm0 120a59.79 59.79 0 01-41-16.21L107.79 23A60 60 0 0164 124z"}}),_c('path',{attrs:{"d":"M26.49 75a2 2 0 00-2 2v24a2 2 0 004 0V77a2 2 0 00-2-2z"}}),_c('path',{attrs:{"d":"M34 47a11 11 0 00-8.43 18 10.15 10.15 0 00-9.08 10v20a2 2 0 004 0V75a6.16 6.16 0 016-6H34a11 11 0 000-22zm0 18a7 7 0 117-7 7 7 0 01-7 7z"}})])
          )
        }
      }
    